import { cn } from "../../lib/utils";

// ظل ثلاثي الأبعاد لعناصر التبويب (نفس أسلوب بطاقات KPI العلوية).
const TAB_3D = {
  boxShadow:
    "0 10px 20px rgba(0,0,0,0.26), 0 5px 8px rgba(0,0,0,0.16),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.30), inset 0 -3px 8px rgba(0,0,0,0.16)",
};

// شريط تبويبات أفقي بأسلوب HELCOO 3D: النشط أزرق صريح، غير النشط أزرق فاتح. fill=يملأ عرض الشاشة.
export const NeuTabs = ({ tabs, value, onChange, testid = "neu-tabs", bare = false, fill = false }) => (
  <div className={bare ? "" : "neu p-2"} data-testid={testid}>
    <div className={cn("flex items-center gap-2.5", fill ? "w-full" : "flex-wrap")}>
      {tabs.map(({ key, label, icon: Icon }) => {
        const active = key === value;
        return (
          <button
            key={key}
            type="button"
            data-testid={`${testid}-${key}`}
            aria-selected={active}
            onClick={() => onChange(key)}
            style={TAB_3D}
            className={cn(
              "flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl px-3.5 py-3 text-sm font-bold",
              "transition-[transform,background-color] duration-300",
              fill ? "min-w-0 flex-1" : "",
              active
                ? "bg-blue-600 text-white"
                : "bg-blue-100 text-blue-700 hover:-translate-y-0.5 hover:bg-blue-200"
            )}
          >
            {Icon ? <Icon className="h-4 w-4 shrink-0" /> : null}
            <span className="truncate">{label}</span>
          </button>
        );
      })}
    </div>
  </div>
);
